import { Link } from 'react-router-dom';
import { Wallet, Eye } from 'lucide-react';
import { formatNumber } from './badgeUtils';

export default function RetainersTab({ retainers, projectId }) {
  if (retainers.length === 0) {
    return <p className="cp-empty">No retainers yet.</p>;
  }

  return (
    <div className="cp-doc-list">
      {retainers.map((ret) => {
        const funded = Number(ret.payments || 0);
        const available = Number(ret.availableBalance || 0);
        const requested = Number(ret.amount || 0);
        const needsFunding = requested > funded;

        return (
          <Link
            key={ret.retainerId}
            to={`/client/projects/${projectId}/retainers/${ret.retainerId}`}
            className="cp-doc-card"
          >
            <div className="cp-doc-icon">
              <Wallet size={20} />
            </div>

            <div className="cp-doc-body">
              <div className="cp-doc-number-row">
                <span>{ret.retainerNumber || 'Retainer'}</span>
              </div>
              <p className="cp-doc-title">{ret.description || 'Retainer'}</p>
              <div className="cp-doc-meta-row">
                {ret.requestDate && <span>Requested: {new Date(ret.requestDate).toLocaleDateString()}</span>}
              </div>
            </div>

            <div className="cp-doc-amounts">
              <div className="cp-doc-amount-col">
                <div className="cp-doc-amount-value">{formatNumber(funded)}</div>
                <div className="cp-doc-amount-label">Funded</div>
              </div>
              <div className="cp-doc-amount-col">
                <div className="cp-doc-amount-value">{formatNumber(available)}</div>
                <div className="cp-doc-amount-label">Available</div>
              </div>
            </div>

            <div className="cp-doc-status">
              {needsFunding ? (
                <span className="cp-btn-primary" style={{ padding: '7px 16px', fontSize: 13 }}>
                  Fund Retainer
                </span>
              ) : (
                <span className="cp-btn-outline" style={{ padding: '7px 16px', fontSize: 13 }}>
                  <Eye size={13} /> View
                </span>
              )}
            </div>
          </Link>
        );
      })}
    </div>
  );
}
